export default __webpack_public_path__ + "static/media/man2.39a9e73f.jpg";